const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});